import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { DataServer } from "../../../sensorconfig.axios";

interface MepsReportState {
  BasicInformation: {
    load: boolean;
    data: [];
  };
  UtilizationSummary: {
    load: boolean;
    data: [];
  };
  OperatorTripSummary: {
    load: boolean;
    data: [];
  };
}

export const MepsReportSlice = createSlice({
  name: "MepsReport",
  initialState: {
    BasicInformation: {
      load: false,
      data: [],
    },
    UtilizationSummary: {
      load: false,
      data: [],
    },
    OperatorTripSummary: {
      load: false,
      data: [],
    },
  } as MepsReportState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getBasicInformation.pending, (state) => {
        state.BasicInformation.load = true;
      })
      .addCase(getBasicInformation.fulfilled, (state, action) => {
        state.BasicInformation.data = action.payload;
        state.BasicInformation.load = false;
      })
      .addCase(getBasicInformation.rejected, (state) => {
        state.BasicInformation.load = false;
      })
      .addCase(getUtilizationSummary.pending, (state) => {
        state.UtilizationSummary.load = true;
      })
      .addCase(getUtilizationSummary.fulfilled, (state, action) => {
        state.UtilizationSummary.data = action.payload;
        state.UtilizationSummary.load = false;
      })
      .addCase(getUtilizationSummary.rejected, (state) => {
        state.UtilizationSummary.load = false;
      })
      .addCase(getOperatorTripSummary.pending, (state) => {
        state.OperatorTripSummary.load = true;
      })
      .addCase(getOperatorTripSummary.fulfilled, (state, action) => {
        state.OperatorTripSummary.data = action.payload;
        state.OperatorTripSummary.load = false;
      })
      .addCase(getOperatorTripSummary.rejected, (state) => {
        state.OperatorTripSummary.load = false;
      });
  },
});

export default MepsReportSlice.reducer;

export const getBasicInformation = createAsyncThunk(
  "MepsReport/getBasicInformation",
  async (param: any) => {
    try {
      var data: any;
      data = await DataServer.get(
        "/api/report/v1/basic_info?warehouse_id=" +
          param.apiParam.warehouse_id +
          "&user_id=" +
          param.apiParam.user_id
      );
      return data.data;
    } catch (error) {
      return error;
    }
  }
);

export const getUtilizationSummary = createAsyncThunk(
  "MepsReport/getUtilizationSummary",
  async (param: any) => {
    try {
      var data: any;
      data = await DataServer.get(
        "/api/report/v1/mhe_utilization_summary?warehouse_id=" +
          param.apiParam.warehouse_id +
          "&user_id=" +
          param.apiParam.user_id +
          "&start_date=" +
          param.apiParam.start_date +
          "&end_date=" +
          param.apiParam.end_date
      );
      return data.data;
    } catch (error) {
      return error;
    }
  }
);

export const getOperatorTripSummary = createAsyncThunk(
  "MepsReport/getOperatorTripSummary",
  async (param: any) => {
    try {
      var data: any;
      data = await DataServer.get(
        "/api/report/v1/mhe_operator_trip_summary?warehouse_id=" +
          param.apiParam.warehouse_id +
          "&user_id=" +
          param.apiParam.user_id +
          "&start_date=" +
          param.apiParam.start_date +
          "&end_date=" +
          param.apiParam.end_date
      );
      return data.data;
    } catch (error) {
      return error;
    }
  }
);
